import React from "react";

import { Modal, theme } from "antd";

import { formatCountdown } from "../utils/session";

interface SessionWarningModalProps {
  open: boolean;
  msRemaining: number;
  onStay: () => void;
}

// Blocking rather than a toast: a toast is invisible in a background tab.
const SessionWarningModal = ({ open, msRemaining, onStay }: SessionWarningModalProps) => {
  // antd wraps its own button styles in :where(), which has zero specificity so apps can
  // override them. Tailwind’s preflight `button { background-color: transparent }` duly
  // does, leaving the primary button white-on-white and invisible. The app’s .ant-btn rule
  // does not rescue it either: the modal is portalled to document.body, outside the
  // container that rule is scoped to. An inline style from the theme token beats both,
  // without hardcoding a colour or touching global CSS other buttons depend on.
  const { token } = theme.useToken();

  return (
    <Modal
      open={open}
      title="Are you still there?"
      closable={false}
      maskClosable={false}
      keyboard={false}
      okText="Stay signed in"
      onOk={onStay}
      okButtonProps={{ style: { backgroundColor: token.colorPrimary, color: token.colorTextLightSolid } }}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <p>You will be signed out in {formatCountdown(msRemaining)} due to inactivity.</p>
    </Modal>
  );
};

export default SessionWarningModal;
